

import TiwiMixin from '../../mixins/TiwiMixin';
import ModalPopup from '../ModalPopup';
import AvatarEditor from './AvatarEditor';

export default {
  mixins: [TiwiMixin],
  components: {
    ModalPopup, AvatarEditor
  },
  props: {
    showModal: {
      required: true,
      default: false,
      type: Boolean
    },
    onSubmit: {
      required: true,
      default: false,
      type: Function
    },
    onClose: {
      required: true,
      default: false,
      type: Function
    },
    currentImage: {
      required: false,
      default: false
    },
    modalId: {
      required: false,
      default: false,
      type: String
    },
    isUserPicture: {
      required: false,
      default: false,
    }
  },
  data() {
    return {
      // showModal: false,
      // old_user_color: null,
      user_color: 'pink',
      save_disabled: true,
      profile_pic_url: this.currentImage || '',
      colors: ['blue', 'pink', 'salmon', 'yellow', 'green'],
      modal_state: 'start',
    }
  },
  mounted: function () {
    this.user_image = null;
    this.user_image_id = null;
  },
  methods: {
    savePicture: function () {
      this.setLoading(true);

      const self = this;

      const post_data = {
        user_image_id: this.isUserPicture ? this.user_image_id : null,
        cover_image_id: this.isUserPicture ? null : this.user_image_id,
        user_color: this.user_color || null
      }

      this.api.post('users/update', post_data)
        .then((response) => {
          if (response.data.success) {
            if (self.user_image) {
              self.toast.success('Immagine impostata correttamente');
            } else {
              self.toast.success('Impostazioni salvate');
            }

            /* if (self.old_user_color !== self.user_color) {
              document.querySelectorAll('.colors-' + self.old_user_color).forEach(element => {
                element.classList.toggle('colors-' + self.old_user_color);
                element.classList.toggle('colors-' + self.user_color);
              });

              self.old_user_color = self.user_color;
            } */

            // Ricarica la pagina dopo 1 secondo se tutto ok
            setTimeout(function () {
              location.reload();
            }, 1000);

            self.save_disabled = true;
            
            self.onSubmit(response, this.profile_pic_url);
            self.setLoading(false);
            self.updateDeskUser(); // faccio la chiamata API per aggiornare su DESK i meta dell'utente
          }
          else {
            console.error(response.data.message);
            self.toast.error('Immagine non caricata. Prova con una più piccola!');
          }
        })
        .catch((error) => {
          self.toast.error('Errore nella richiesta');
        })
        .finally(() => self.setLoading(false))
    },
    handleFileChange(e) {
      const selected_image = e.target.files[0];
      this.setLoading(true);

      const self = this;
      this.uploadMedia(selected_image, function (response) {
        self.profile_pic_url = response.data.attachment_url;
        self.user_image_id = response.data.media_id;
        self.save_disabled = false;
      }, () => {
        self.toast.error('Immagine non caricata. Riprova con una più piccola.');
      }, () => {
        self.setLoading(false);
      })//, this.block.attrs.id);
    },
    setProfileColor(color) {
      this.user_color = color;
      this.save_disabled = false;
    },
    enableAvatarEditor(){
      this.modal_state = 'avatar-editor';
    },
    // submitAvatarPicture( svg, base64){
    submitAvatarPicture( svg, user_config){
      
      this.setLoading(true);

      const self = this;

      const post_data = {
        svg: svg,
        user_config: user_config,
        //base64: base64,
        
      }

      this.api.post('users/saveSvgAvatar', post_data)
        .then((response) => {
          if (response.data.success) {
            
              self.toast.success('Immagine impostata correttamente');

              self.profile_pic_url = response.data.attachment_url;
              self.user_image_id = response.data.media_id;
            

           

            // Ricarica la pagina dopo 1 secondo se tutto ok
            
            setTimeout(function () {
              location.reload();
            }, 1000);
            
            

            self.save_disabled = true;
            
            self.onSubmit(response, this.profile_pic_url);
            self.setLoading(false);
            self.updateDeskUser(); // faccio la chiamata API per aggiornare su DESK i meta dell'utente
          }
          else {
            console.error(response.data.message);
            self.toast.error('Immagine non caricata. Prova con una più piccola!');
          }
        })
        .catch((error) => {
          self.toast.error('Errore nella richiesta');
        })
        .finally(() => self.setLoading(false))
    }
  },
  watch: {
    user: function (user) {
      this.user_color = user.meta.user_color;
      // this.old_user_color = user.meta.user_color;
    }
  }
}
